import React from 'react';
import { AppState, Platform, StatusBar } from 'react-native';
import ThemeContextView from 'states/context/views/ThemeContextView';
import IPhoneXHelper from '../../libs/IPhoneXHelper';

export default class BaseStatusBar extends ThemeContextView {
  constructor(props) {
    super(props);
    this.state = { tick: 0 };
  }

  componentDidMount() {
    if (Platform.OS === 'android') {
      this.mountTimer = setTimeout(() => this.setState({ tick: 1 }), 100);
      this.appStateSubscription = AppState.addEventListener('change', this.handleAppStateChange);
    }
  }

  componentWillUnmount() {
    if (this.appStateSubscription) this.appStateSubscription.remove();
    if (this.mountTimer) clearTimeout(this.mountTimer);
  }

  handleAppStateChange = (nextAppState) => {
    if (nextAppState === 'active') this.setState({ tick: Date.now() });
  };

  render() {
    const { darkMode, statusBarHeight = IPhoneXHelper.getStatusBarHeight() } = this.context || {};
    const barStyle = darkMode ? 'light-content' : 'dark-content';
    return <StatusBar translucent={true} barStyle={barStyle} hidden={statusBarHeight === 0} backgroundColor={'transparent'} />;
  }
}
